var __c__ = function(a){
  if(isDebug){
    console.log(a);
  }
};

var isSPFirefox = (function(){
  var _ua = navigator.userAgent.toLowerCase();
  if(_ua.indexOf('mobile') > -1 && _ua.indexOf('firefox') > -1 && _ua.indexOf('android') > -1 ){
    return true;
  }
  return false;
})();

__c__("isSPFirefox: " + isSPFirefox);

var Init = function(){
  var $window = $(window);

  // 規約見てから
  var $termBtn = $("#term_check_btn");
  var TermChecked = function(){
    $('.term-check').css({display: 'none'});
    $('.form').css({display: 'block'});
    $(".modal-wrap").scrollTop(0);
  };

  var TermScroll = function(){
    var _target = $(event.currentTarget);
    var _currentScrollPos = _target.get(0).scrollHeight - _target.innerHeight() - _target.scrollTop();
    if(_currentScrollPos < 10){
      __c__('term scroll checked')
      $('#term_check_label').removeClass('disabled');
      $termBtn.on('click', TermChecked);
      $('#term_scroll').off('scroll', TermScroll);
    }
  };
  $('#term_scroll').on('scroll', TermScroll);


  // Form関連
  var $video = $("#video");
  var $videoFileName = $("#video_file_name").css({display: "none"});
  var $videoPreview = $("#video_preview").css({display: "none"});
  var videoReader = new FileReader();

  var videoResult = null;

  var videoFileUpload = function(event){
    __c__("videoFileUpload");
    $videoFileName.css({display: "none"});
    //$videoPreview.css({display: "none"});

    if(event.target.files[0]){
      __c__(event.target.files[0]);
      var _file = event.target.files[0];
      var _fileName = _file.name;
      if(event.target.files[0].size > 1024 * 1024 * 1024){
        //__c__(event.target.files[0].size);
        alert("動画ファイルは1GBまででお願いします");
        return;
      }
      var _onload;
      videoReader.readAsDataURL(_file);
      _onload = function(event){
        __c__(videoReader);
        var video = document.createElement("video");
        var forCheckVideo = function(){
          __c__("forCheckVideo");
          __c__(video.duration);
          if(video.duration <= 60){
            videoResult = videoReader.result;
            /*__c__("videoResult:");
            __c__(videoResult);*/
            $videoFileName.text("動画ファイル名: " + _fileName);
            $videoFileName.css({display: "block"});
          }else{
            alert("動画の長さは1分まででお願いします");
          }
          video.ondurationchange = null;
          video = null;
          videoReader.removeEventListener("load", _onload);

        };
        video.src = URL.createObjectURL(_file);
        video.ondurationchange = forCheckVideo;
      };
      videoReader.addEventListener("load", _onload);
    }
  };
  $video.on("change", videoFileUpload);


  var $files = $("input[type=file]");
  var $inputs = $(".form input[required], .form select[required], .form textarea[required]");
  var maxAmount = 5;
  var _readers = [];
  var _files = [];
  var $container = $("#input_container");
  var $thumbs = $("#photo_thumb");


  var UploadNext = function(current){
    __c__("UploadNext");
    __c__(current);
    var _currentImageNum = current;
    var _nextImageNum = _currentImageNum + 1;
    if(_nextImageNum <= maxAmount){
      $(".photo" + _currentImageNum).addClass("disappear");
      var _label = $("<label for='photo" + _nextImageNum + "' class='photo photo" + _nextImageNum + "'></label>");
      var _txt = $("<p class='photo--input'>写真をアップロードする</p>");
      var _input = $("<input type='file' id='photo" + _nextImageNum + "' name='images[]' accept='image/*'>");
      _label.append(_txt);
      _label.append(_input);
      $container.append(_label);
      SetUpload(current);
    }else if(_nextImageNum > maxAmount){
      $(".photo" + _currentImageNum).addClass("disappear");
    }
  };

  let FileUpload = (event) => {
    __c__("FileUpload");
    var _num = event.data.num;
    __c__(_num);

    if(event.target.files[0]){
      __c__(event.target.files[0].size);
      if(event.target.files[0].size > 1024 * 1024 * 1024){
        //__c__(event.target.files[0].size);
        alert("動画ファイルは1GBまででお願いします");
        return;
      }
      var _onload;
      var _isExist = $("#image" + (_num + 1)).length > 0;
      var _thisReader = _readers[_num];
      _thisReader.readAsDataURL(event.target.files[0]);

      if(_isExist){
        var _img = $("#image" + (_num + 1))[0];
        _img.src = "";
      }else{
        var _img = new Image();
        _img.id = "image" + (_num + 1);
        var _label = $("<label for='photo" + (_num + 1) + "'></label>");
        _label.append(_img);
        $thumbs.append(_label);
      }

      _img.style.display = "none";

      _onload = function(){
        //console.dir(_thisReader.result);
        _img.src = _thisReader.result;
        _img.style.display = "block";
        _thisReader.removeEventListener("load", _onload);
        var _next = _num + 1;
        if(!_isExist){
          UploadNext(_next);
        }
      };
      _thisReader.addEventListener("load", _onload);
    }
  };

  var SetUpload = function(num){
    __c__("SetUpload");
    __c__(num);
    var $reader = new FileReader();
    var $file = $("#photo" + String(num + 1));
    if($file.value !== null){
      //$file.value = null;
    }
    _readers[num] = $reader;
    _files[num] = $file;
    $file.on("change", {num: num}, FileUpload);
    $reader.onerror = function(event){
      __c__('file upload error');
    };
    $reader.onload = function(event){
      __c__('file upload loaded');
    };
  };
  //SetUpload(0);

  var CheckRequire = function(){
    __c__("CheckRequire");
    var _validCount = $inputs.length;
    $inputs.each(function(){
      if(this.value === "" || this.value === null){
        $("#confirm").addClass("disabled");
      }else{
        if(this.getAttribute('data-amount-check') === 'false'){
          $("#confirm").addClass("disabled");
        }else{
          _validCount--;
        }
      }
    });

    __c__("_validCount: " + _validCount);

    if(_validCount === 0){
      $("#confirm").removeClass("disabled");
    }
  }
  $inputs.on("change", CheckRequire);
  CheckRequire();

  var _isBlur = true;
  var CheckTextAmount = function($elm, maxLength){
    var _$amount = $elm.parent().find('.amount');
    var _CheckTextFocus = function(event){
      __c__('_CheckTextFocus');

      var _timer = setInterval(function(){
        if(_isBlur) {
          __c__('_CheckTextBlur is ON');
          _isBlur = false;
          $elm.on('blur', _CheckTextBlur);
          clearInterval(_timer);
        }
      }, 500);
    }

    var _CheckTextBlur = function(event){
      __c__('_CheckTextBlur');
      $elm.off('blur', _CheckTextBlur);

      var __target = event.currentTarget;

      if(!_isBlur){
        if(__target.value.length > maxLength){
          alert($(__target).data("name") + "は " + maxLength.toString() + ' 文字以内でご記入ください。');
        }
        CheckRequire();
        var _timer = setTimeout(function(){
          _isBlur = true;
          clearTimeout(_timer);
        }, 500);
        __c__('_CheckTextBlur is OFF');
      }


    };

    var _CheckTextInput = function(event){
      var __target = event.currentTarget;
      _$amount.text(__target.value.length.toString() + ' / ' + maxLength.toString() + '文字');
      if(__target.value.length > maxLength){
        $(__target).attr('data-amount-check', 'false');
        $(__target).addClass('error');
      }else{
        $(__target).attr('data-amount-check', 'true');
        $(__target).removeClass('error');
      }
    };

    $elm.on('focus', _CheckTextFocus);
    $elm.on('input', _CheckTextInput);

  };
  CheckTextAmount($('.modal #title'), 20);
  CheckTextAmount($('.modal #contents'), 1000);

  var _select = $("select");
  var ChangeSelect = function(event){
    var _target = $(event.currentTarget);
    var _value = _target.val();
    if(_value !== ""){
      _target.addClass("selected");
    }
  };
  _select.on("change", ChangeSelect);

  var $submitBtn = $('#submit');

  $('#confirm').click(function(){
    __c__("confirm clicked");
    var falseCount = 0;
    $(".form input[required], .form select[required], .form textarea[required]").each(function(){
      if(!this.reportValidity()){
        falseCount++;
        //return false;
      }
    });

    if(falseCount === 0){
      $(".modal-wrap").scrollTop(0);

      $("#video_file_name_confirm").empty().html($("#video_file_name").text());
      $("#attempt_confirm").empty().html($("#attempt").val());
      $("#theme_confirm").empty().html($("#theme").val());
      $("#title_confirm").empty().html($("#title").val());
      $("#contents_confirm").empty().html($("#contents").val());
      $("#photo_thumb_confirm").empty();
      $("#photo_thumb img").each(function(){
        var _cloneImage = new Image();
        var _lebel = $("<label></label>");
        _cloneImage.src = this.src;
        _lebel.append(_cloneImage);
        $("#photo_thumb_confirm").append(_lebel);
      });
      $("#facility_confirm").empty().html($("#facility").val());
      $("#store_name_confirm").empty().html($("#store_name").val());
      $("#store_category_confirm").empty().html($("#store_category").val());
      $("#nickname_confirm").empty().html($("#nickname").val());
      $("#name_confirm").empty().html($("#name").val());
      $("#email_confirm").empty().html($("#email").val());

      $(".input").css({display: "none"});
      $(".confirm").css({display: "block"});
    }else{
      __c__(falseCount);
    }
  });

  $('#modify').click(function(){
    $(".modal-wrap").scrollTop(0);
    $(".input").css({display: ""});
    $(".confirm").css({display: "none"});
  });


  var endpointJqxhr = null;
  var uploadJqxhr = null;
  var jqxhr = null;

  var categoryKey = null;

  if(isDebug){
    // categoryKey = "inlmtulgo355tax8"; // TESTカテゴリ
    //categoryKey = "x2iosba0dmzxfar4"; // TEST2 カテゴリ
    categoryKey = "12h2jd31yu9zz03u"; // TEST3 カテゴリ

    __c__( "Debug: " + categoryKey);
  }else{
    if(currentPhase === 'phase1'){
      categoryKey = "ac63nixo3o8nv890"; // Phase1 カテゴリ
    }else if(currentPhase === 'phase2'){
      categoryKey = "b9o8xin9msm3zmg8"; // Phase2 カテゴリ
    }else if(currentPhase === 'phase3'){
      categoryKey = "lx6jdu4vyixpyu6q"; // Phase3 カテゴリ
    }else{
      categoryKey = "12h2jd31yu9zz03u"; // TESTカテゴリ
    }

    __c__(currentPhase + ": " + categoryKey);
  }


  var kollusEndpoint = function(video_data, form_data){

    __c__("kollusEndpoint");
    __c__("video_data:");
    __c__(...video_data.entries());
    __c__("form_data:");
    __c__(...form_data.entries());

    endpointJqxhr = $.ajax({
      url: 'https://api.jp.kollus.com/0/media_auth/upload/create_url',
      type:'POST',
      data: {
        "access_token": "bf9bdmri12bm5gf0",
        "category_key": categoryKey,
        "title": form_data.get('title'),
        /*"is_passthrough": 1,
        "profile_key": "leadalliance-mobile1-normal",*/
      },
      dataType: 'json',
    })
      .done(function(data) {
        __c__(data);
        /*
        * Sample
        {
            "error": 0,
            "message": "",
            "result": {
                "upload_url": "http: //upload.jp.kollus.com/api/v1/UploadMultiParts/KUS_BOHG2eTQhPSIaG2511G1jfkpWOYAOjDc/20151204-dh6o2goz",
                “progress_url”: “http: //upload.jp.kollus.com/api/v1/GetUploadingProgress/KUS_BOHG2eTQhPSIaG2511G1jfkpWOYAOjDc”,
                "upload_file_key": "20141017-y4sae7td",
                "will_be_expired_at": 1413883670
            }
        }
        * */
        kollusFileUpload(video_data, data.result, form_data);
      })
      .fail(function(XMLHttpRequest, textStatus, errorThrown) {
        if(textStatus === "timeout"){
          alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
        }else{
          //console.dir(formData.getAll('images[]'));
          console.dir(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);

          var _message = '';
          if(XMLHttpRequest.responseJSON !== undefined){
            var _keys = Object.keys(XMLHttpRequest.responseJSON.message);
            if(_keys.length > 0){
              for(let key in XMLHttpRequest.responseJSON.message){
                _message += XMLHttpRequest.responseJSON.message[key] + ',';
              }
            }
          } else if(XMLHttpRequest.responseText !== undefined) {
            _message += XMLHttpRequest.responseText;
          }
          if(textStatus !== 'abort'){
            alert('送信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + _message + ' >>');
          }
        }
        endpointJqxhr.abort();
      });
  };

  /**
   * @name kollusFileUpload
   * @param video_data
   * @param result
   * @param form_data
   *
   * task: Android Firefoxで動かない
   */
  var kollusFileUpload = function(video_data, result, form_data){
    __c__("kollusFileUpload");

    //video_data.append('disable_alert', 0);
    //video_data.append('redirection_scope', 'no');
    //video_data.append('accept', 'application/json');
    __c__("video_data:");
    console.log(...video_data.entries());

    __c__("result:");
    __c__(result);

    form_data.append('upload_file_key', result['upload_file_key']);
    __c__("form_data:");
    console.log(...form_data.entries());

    uploadJqxhr = $.ajax({
      url: result["upload_url"],
      type:'POST',
      dataType: 'json',
      data: video_data,
      processData: false,
      contentType: false,
    }).done(function(data) {
      __c__('success upload');
      __c__(data);
      if(data.error === 0){
        setAPI(form_data)
      }else{
        alert('アップロードエラーです。' + data.message );
      }
    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
      if(textStatus === "timeout"){
        alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
      }else{
        //console.dir(formData.getAll('images[]'));
        console.dir(XMLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
        var _message = '';
        if(XMLHttpRequest.responseJSON !== undefined){
          var _keys = Object.keys(XMLHttpRequest.responseJSON.message);
          if(_keys.length > 0){
            for(let key in XMLHttpRequest.responseJSON.message){
              _message += XMLHttpRequest.responseJSON.message[key] + ',';
            }
          }
        } else if(XMLHttpRequest.responseText !== undefined) {
          _message += XMLHttpRequest.responseText;
        }
        if(textStatus !== 'abort'){
          alert('送信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + _message + ' >>');
        }
      }
      uploadJqxhr.abort();
      //window.location.reload();
    });
  }

  var setAPI = function(form_data){
    __c__("setAPI");
    __c__("form_data:");
    console.log(...form_data.entries());

    var _success = function(){
      $(".confirm").css({display: "none"});
      $(".thanks").css({display: "block"});
      $(".form-overlay").removeClass("form-overlay-appear");

      $('.modal-content[data-modal-content=form]').find('.modal--close').addClass('reload');

      $submitBtn.delay(500).queue(function(){
        $submitBtn.dequeue();
        window.removeEventListener('popstate', _back);
      });
    };

    //_success();

    jqxhr = $.ajax({
      url: _vars.path + 'post',
      type:'POST',
      headers: {
        "api-key" : _vars.key
      },
      dataType: 'json',
      data: form_data,
      processData: false,
      contentType: false,
      timeout: 10000,
    }).done(function(data) {
      __c__('success post');
      //__c__(data);
      _success();

    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
      if(textStatus === "timeout"){
        alert('通信がタイムアウトしました。通信環境の良いところで再度お試しください。');
      }else{
        //console.dir(formData.getAll('images[]'));
        console.dir(XMLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
        var _message = '';
        var _keys = Object.keys(XMLHttpRequest.responseJSON.message);
        if(_keys.length > 0){
          for(let key in XMLHttpRequest.responseJSON.message){
            _message += XMLHttpRequest.responseJSON.message[key] + ',';
          }
        }
        if(textStatus !== 'abort'){
          alert('送信エラーが発生しました。\nお手数をおかけしますが時間をあけて再度お試しください。\n error text: <<' + + XMLHttpRequest.status + ' / ' + textStatus + ' / ' + _message + ' >>');
        }
      }
      jqxhr.abort();
      $(".modal-wrap").scrollTop(0);
      $(".input").css({display: ""});
      $(".confirm").css({display: "none"});
      $submitBtn.removeClass("disabled");
      $(".form-overlay").removeClass("form-overlay-appear");
      window.removeEventListener('popstate', _back);
      //window.location.reload();
    });
  }

  var _back = function(){
    __c__("browser back");

    if(endpointJqxhr){
      endpointJqxhr.abort();
      __c__("endpointJqxhr.abort");
    }
    if(uploadJqxhr){
      uploadJqxhr.abort();
      __c__("uploadJqxhr.abort");
    }
    if(jqxhr){
      jqxhr.abort();
      __c__("jqxhr.abort");
    }
    window.removeEventListener('popstate', _back);
  }

  var isSubmitOnce = false;
  $submitBtn.click(function(){

    var video_obj = document.getElementById('video_form');
    var form_obj = document.getElementById('movie_form');

    var videoData = new FormData(video_obj);
    var formData = new FormData(form_obj);

    __c__("--UPLOAD START--");
    __c__("isSubmitOnce");
    __c__("videoData:");
    __c__(...videoData.entries());
    __c__("formData:");
    __c__(...formData.entries());

    var falseCount = 0;

    $(".form input[required], .form select[required], .form textarea[required]").each(function(){
      if(!this.reportValidity()){
        falseCount++;
        //return false;
      }
    });

    if(falseCount === 0 && !$submitBtn.hasClass("disabled")){
      //if(falseCount === 0){
      $submitBtn.addClass("disabled");
      $(".form-overlay").addClass("form-overlay-appear");

      if(!isSubmitOnce){
        history.pushState(null, null, null);
        isSubmitOnce = true;
      }else{
        history.replaceState(null, null, null);
      }

      window.addEventListener('popstate', _back);

      kollusEndpoint(videoData, formData);


    }else{
      console.log("validation is false. Cant Post Form Data.")
    }
  });
};

window.addEventListener("load", Init);